export default __webpack_public_path__ + "static/media/DSC03419-1-point-5-768x513.62e51796.jpg";